export const setToken = (formData) => {
    return {
      type: 'SET_TOKEN',
      payload: formData,
    };
};

export const setStatus = (formData) => {
  return {
    type: 'SET_STATUS',
    payload: formData,
  };
};

export const setTransaction = (formData) => {
  return {
    type: 'SET_TRANSACTION',
    payload: formData,
  };
};

export const setTransactionInitialData = (formData) => {
  return {
    type: 'SET_TRANSACTION_INITIAL_DATA',
    payload: formData,
  };
}

export const setReuse = (formData) => {
  return {
    type: 'SET_REUSE',
    payload: formData,
  }
}

/** Clears only the Token slice. Use when you need to clear auth without touching CSR/form state. */
export const resetToken = () => {
  return {
    type: 'RESET',
  }
}

/** Clears all certificate/CSR flow state (Token, CompleteInfo, FirstInfo, TokenGenerateKeyResponse, Stepper). Call when user lands on login or landing so the next user does not see previous user's data. */
export const resetCertificateFlow = () => {
  return {
    type: 'RESET_CERTIFICATE_FLOW',
  }
}
  